package pogolitics.controller

val ABSOLUTE_MAX_LEVEL = 41.0F
val BASIC_MAX_LEVEL = 40.0F
val MAX_GREAT_CP = 1500
val MAX_ULTRA_CP = 2500